import React from 'react';
import CrmObjectsPage from '../components/CrmObjectsPage';

const CrmObjectsApp = (props) => <CrmObjectsPage {...props} />;

export default CrmObjectsApp;
